<script setup lang="ts">import { computed as _computed } from 'vue';

import formatDate from '@/utils/filters/formatDate';
import fromNow from '@/utils/filters/fromNow';
import capitalizeFirst from '@/utils/filters/capitalizeFirst';

interface DateTooltipProps {
  value?: string | number;
  capitalize?: boolean;
}

const props = defineProps({
  value: null,
  capitalize: { type: Boolean, default: false }
});

const formattedDate = _computed(() => (props.value ? formatDate(props.value) : ''));

const fromNowDate = _computed(() => (props.capitalize ? capitalizeFirst(fromNow(props.value)) : fromNow(props.value)));
</script>

<template lang="pug">
span
  v-tooltip( top )
    template( v-slot:activator='{ on }' )
      span.grey--text( v-on='on' class="date-tooltip" ) {{ fromNowDate }}
    span {{ formattedDate }}
</template>

<style lang="scss">
.date-tooltip {
  cursor: pointer;
}
</style>
